import * as React from "react";
import { Anchor } from "../typography/anchor/anchor.mjs";
import { Container } from "../container/container.mjs";
import { List } from "../list/list/list.mjs";
import { ListItem } from "../list/list-item/list-item.mjs";
const SkipLinks = (props) => {
  const renderItems = (links) => {
    return links.map((link, key) => {
      var _a;
      const { label, ...rest } = link;
      return /* @__PURE__ */ React.createElement(ListItem, { key: (_a = link.id) != null ? _a : key }, /* @__PURE__ */ React.createElement(
        Anchor,
        {
          ...rest,
          isTextColor: true,
          isUnderlined: false,
          className: "skip-links__anchor",
          attributes: {
            onFocus: props.setHeaderHeight,
            onBlur: props.setHeaderHeight
          }
        },
        label
      ));
    });
  };
  return /* @__PURE__ */ React.createElement("div", { className: "skip-links" }, /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(List, { bordered: true, direction: "inline", type: "unstyled", className: "skip-links__list" }, renderItems(props.links))));
};
export {
  SkipLinks
};
